import { OperationVariables } from "@apollo/client";
import { NotFoundError, useGraphQuery } from "@dashboard/library";
import { OperationDefinitionNode } from "graphql";
import { buildDataDogMessage } from "@/helpers/string/string.helpers";
import { useInfo } from "../useInfo/useInfo";
import {
  Options,
  Query,
  UseQueryWrapperReturnType,
} from "./useQueryWrapper.decl";

export function useQueryWrapper<
  DataType = OperationVariables,
  OptionsType = OperationVariables,
>(
  query: Query<DataType, OptionsType>,
  options?: Options<DataType, OptionsType>
): UseQueryWrapperReturnType<DataType, OptionsType> {
  const { info } = useInfo();

  const { error, ...rest } = useGraphQuery(query, {
    ...options,
    throwError: false,
  });

  const hasError = !!error;

  if (hasError) {
    const payload = {
      options,
      error,
    };

    const queryName = (query.definitions[0] as OperationDefinitionNode).name
      ?.value;

    info(buildDataDogMessage({ message: error.message, queryName }), payload);
  }

  if (options?.shouldThrowError && hasError) {
    if (error.message.includes("404")) {
      throw new NotFoundError("Page not found.");
    }

    throw error;
  }

  return { error, ...rest };
}
